import { render, staticRenderFns } from "./TdxInfoBlock.vue?vue&type=template&id=455122ba&scoped=true&"
import script from "./TdxInfoBlock.vue?vue&type=script&lang=js&"
export * from "./TdxInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./TdxInfoBlock.vue?vue&type=style&index=0&id=455122ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455122ba",
  null
  
)

export default component.exports